module.exports = __webpack_public_path__ + "static/media/thumb.4988daa5.jpg";